// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__hRC3L","border":"Table_border__l3Pbu","table":"Table_table__taW2B","header":"Table_header__bE1Py"};